import React, { Component } from 'react';
import Fade from "react-reveal/Fade";
import LinkButton from "components/Components/UI/LinkButton";
import PropTypes from "prop-types";

class CallUs extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        //Force Callrail swap
        if (window.CallTrk)
        {
            window.CallTrk.swap()
        }
    }

    render() {

        const {
            bgColor,
            showEmailButton
        } = this.props;

        return (
            <section className={`tw-py-10 lg:tw-py-20 tw-px-4 ${bgColor}`}>
                <div className="xl:tw-container tw-text-center">
                    <Fade bottom>
                        <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12">Need a hand planning your Trip?</h2>
                    </Fade>
                    <Fade bottom>
                        <div className="tw-flex tw-flex-wrap lg:tw-justify-center">
                            <div className="tw-w-full lg:tw-w-2/3">
                                <h4 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-mb-4 lg:tw-mb-6 tw-mt-12">
                                    Our team of travel experts know each and every one of the properties in our collection.
                                    From outstanding oceanfront hotels in Florida to the best Caribbean resorts, we'll help you
                                    plan a luxury beach vacation to remember.
                                </h4>
                                <h5 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-mb-4 lg:tw-mb-6 tw-mt-12">
                                    <a className="hover:tw-text-orange-400" href="tel:18447858575">
                                        <span className="!tw-text-gray-700">Call us today at:</span> 1 (844) 785-8575
                                    </a>
                                </h5>
                                {
                                    showEmailButton ?
                                    <LinkButton
                                        text={'Email us'}
                                        className={'tw-mt-4 tw-w-full md:tw-w-auto'}
                                        color={'gray'}
                                        tab={'_blank'}
                                        to={'/contact-us'}
                                    /> : null
                                }

                            </div>
                        </div>
                    </Fade>
                </div>
            </section>
        );
    }
}

CallUs.propTypes = {
    bgColor: PropTypes.string,
    showEmailButton: PropTypes.bool
};

CallUs.defaultProps = {
    showEmailButton: true
}

export default CallUs;
